export default __webpack_public_path__ + "static/media/ellipsis_menu_icon.ec225961.svg";